module.exports = __webpack_public_path__ + "static/img/user2.ac3eb459.png";